import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const mwbConfig: IConfigsType = {
  mwb: {
    '/:brand/systemwide_overview': {
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'trailing_90_days',
          'custom',
        ],
      },
      variables: ['allStores'],
      systemwideOverview: {
        type: 'list',
        api: 'systemwideOverviewKpis',
        title: 'Systemwide Overview',
        fieldWidth: '120px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Net Sales',
          },
          {
            content: {
              key: 'averageWeeklySales',
            },
            bottom: 'Company Average Weekly Sales',
          },
          {
            content: {
              key: 'expoMSssPercent',
            },
            bottom: 'SSS %',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            content: {
              key: 'variableLaborCost',
            },
            bottom: 'Variable Labor %',
          },
          {
            content: {
              key: 'actualFbPercent',
            },
            bottom: 'Actual %',
          },
          {
            content: {
              key: 'theoreticalFbPercent',
            },
            bottom: 'Theoretical %',
          },
          {
            content: {
              key: 'avtFbPercent',
              color: '<%- value > 0.5 ? colors.Pomodoro : "" %>',
            },
            bottom: 'Variance %',
          },
        ],
      },
      breakdownByStore: {
        type: 'table',
        api: 'systemwideOverview',
        title: 'Breakdown by Store',
        pageSize: 50,
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '200px',
          },
        },
        columns: [
          {
            key: 'Sales',
            title: 'Net Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'netSales',
                title: 'Actual $',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesBudgetVarianceAmount',
                title: 'Variance $',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesBudgetVariance',
                title: 'Variance %',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'Weekly Sales',
            title: 'Weekly Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'avgWeeklySales',
                title: '$',
                align: 'center',
                sortable: true,
              },
            ],
          },
          {
            key: 'AvT',
            title: 'AvT',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'actualFbPercent',
                title: 'Actual %',
                align: 'center',
                sortable: true,
              },
              {
                key: 'theoreticalFbPercent',
                title: 'Theoretical %',
                align: 'center',
                sortable: true,
              },
              {
                key: 'avtFbPercent',
                title: 'Variance %',
                align: 'center',
                sortable: true,
                danger: 'positive',
                dangerThreshold: 0.5,
              },
            ],
          },
          {
            key: 'VariableLabor',
            title: 'Variable Labor',
            align: 'center',
            children: [
              {
                key: 'variableLaborCost',
                title: '%',
                align: 'center',
                sortable: true,
              },
              {
                key: 'laborVariance',
                title: 'Variance to Plan %',
                align: 'center',
                sortable: true,
                decimal: 1,
                danger: 'positive',
                dangerThreshold: 0,
              },
            ],
          },
        ],
      },
      revenueCenterAndDayPart: {
        type: 'grid',
        children: {
          revenueCenter: {
            type: 'table-v2',
            api: 'locationGroupRevenueCenter',
            title: 'Revenue Center',
            columns: [
              {
                key: 'name',
                title: 'Revenue Center',
                sortable: true,
              },
              {
                key: 'sales',
                title: 'Net Sales',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
              {
                key: 'checkCount',
                title: 'Check Count',
                sortable: true,
              },
              {
                key: 'checkAverage',
                title: 'Check Average',
                unit: 'dollar',
                decimal: 2,
                sortable: true,
              },
            ],
          },
          dayPart: {
            type: 'table-v2',
            api: 'locationGroupDayPart',
            title: 'Day Part',
            columns: [
              {
                key: 'name',
                title: 'Day Part',
                sortable: true,
              },
              {
                key: 'sales',
                title: 'Sales',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'salesPerHour',
                title: 'Sales per Hour',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
              {
                key: 'checkCount',
                title: 'Check Count',
                sortable: true,
              },
              {
                key: 'checkAverage',
                title: 'Check Average',
                unit: 'dollar',
                decimal: 2,
                sortable: true,
              },
            ],
          },
        },
      },
      averageWeeklySales: {
        type: 'line-chart',
        title: 'Average Weekly Sales',
        api: 'trendLocationGroupFinancialKpis',
        width: 1100,
        height: 350,
        label: 'date',
        datasets: [
          {
            key: 'avgWeeklySales',
            label: 'Net Sales',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
          },
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              title: {
                text: '$',
              },
            },
          },
        },
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'systemwide-overview',
        sendStoreId: false,
      },
      feV2ChatBox: {
        type: 'feV2-chatbox',
        agentType: 'location',
        hideFromNonExpoUsers: true,
        disableInputField: false,
        sendStoreId: false,
        description: 'Ask about sales performance',
        bubblePrompts: [
          {
            id: 'sales',
            label: 'Sales',
            prompt: 'Show me the sales performance',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'sales_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'sales_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'sales_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales',
          },
          {
            id: 'daypart',
            label: 'Day Part',
            prompt: 'Show me the sales performance by day part',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'daypart_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'daypart_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'daypart_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-daypart',
          },
          {
            id: 'revenue-center',
            label: 'Revenue Center',
            prompt: 'Show me the sales performance by revenue center',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'revenue-center_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'revenue-center_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'revenue-center_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-revenue-center',
          },
          {
            id: 'labor',
            label: 'Labor',
            prompt: 'Show me the labor performance',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'labor_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'labor_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'labor_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:labor',
          },
          {
            id: 'labor-daypart',
            label: 'Labor Day Part',
            prompt: 'Show me the labor performance by day part',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'labor-daypart_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'labor-daypart_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'labor-daypart_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:labor-daypart',
          },
          {
            id: 'labor-position',
            label: 'Labor Position',
            prompt: 'Show me the labor performance by position',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'labor-position_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'labor-position_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'labor-position_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:labor-position',
          },
        ],
      },
      map: {
        type: 'map',
        api: 'listGeoInfo',
      },
    },
  },
}

export default mwbConfig
